module.exports = __webpack_public_path__ + "img/no-data.cd2812ac.png";